import React from 'react';
import MoldCard from './MoldCard';
import { Mold } from '../../types/mold';

interface MoldCardViewProps {
  molds: Mold[];
  selectedMolds: string[];
  onSelect: (moldId: string) => void;
}

export const MoldCardView: React.FC<MoldCardViewProps> = ({
  molds,
  selectedMolds,
  onSelect,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {molds.map((mold) => (
        <MoldCard
          key={mold.id}
          mold={mold}
          isSelected={selectedMolds.includes(mold.id)}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

export default MoldCardView;
